import { Component} from '@angular/core';
import { RouterLinkActive } from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent  {

  constructor(){}
}



// WEBPACK FOOTER //
// E:/UniServerZ/www/seo/wp-content/plugins/dvin508-ada-seo/seo/src/app/app.component.ts